const angular = require('angular');

const loadingIndicatorService = require('./loading-indicator.service');
const { loadingIndicatorComponentDefinition } = require('./loading-indicator.component');

angular.module('wowApp.common')
    .service('LoadingIndicatorService', loadingIndicatorService)
    .component('wowLoadingIndicator', loadingIndicatorComponentDefinition);



// WEBPACK FOOTER //
// ./src/common/loadingindicator/index.js